import React from "react";

const SubmitButton = (props) => {
  return (
    <button
      type="submit"
      disabled={props.loading}
      className={
        "btn btn-secondary submit-button position-relative mb-3" +
        (props.loading ? " disabled" : "")
      }
    >
      {props.value}
      {props.loading ? (
        <div className="loader"></div>
      ) : (
        <i className="fas fa-arrow-right"></i>
      )}
    </button>
  );
};

export default SubmitButton;
